// extracted by mini-css-extract-plugin
module.exports = {"container":"TabActionBar_container__p9s1J","StyledTabs":"TabActionBar_StyledTabs__3cMY5"};